import { Text } from "pixi.js";
import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";
import { PiggyViewHeaderComponent } from "./PiggyViewHeaderComponent";
import { PiggyViewTextStyle } from "../textstyle/PiggyViewTextStyle";
import { PiggyViewSmallTextStyle } from "../textstyle/PiggyViewSmallTextStyle";

export class PiggyViewLockedHeaderComponent extends PiggyViewHeaderComponent {
    private static readonly TOP_TEXT = 'NEW PIGGY BANK CREATED';
    private static readonly MIDDLE_TEXT = 'UNLOCK AT LEVEL ';
    private static readonly BOTTOM_TEXT = '(CURRENTLY, YOU ARE LEVEL ';

    private readonly isNewBank: boolean;

    private topText: Text;
    private middleText: Text;
    private bottomText: Text;

    public constructor(
        piggyResources: PiggyResourcePackage,
        currentLevel: number,
        openAtLevel: number,
        isNewBank: boolean
    ) {
        super(piggyResources);
        this.isNewBank = isNewBank;
        this.build(currentLevel, openAtLevel);
        this.layout();
    }

    private build(currentLevel: number, openAtLevel: number): void {
        this.middleText = new Text(PiggyViewLockedHeaderComponent.MIDDLE_TEXT + openAtLevel, new MiddleTextStyle());
        this.middleText.skew.x = -0.087;
        this.middleText.angle = -5;
        this.bottomText = new Text(PiggyViewLockedHeaderComponent.BOTTOM_TEXT + currentLevel + ')', new PiggyViewSmallTextStyle());
        this.bottomText.skew.x = -0.087;
        this.bottomText.angle = -5;
        this.addChild(this.middleText, this.bottomText);
        if (this.isNewBank) {
            this.topText = new Text(PiggyViewLockedHeaderComponent.TOP_TEXT, new TopTextStyle());
            this.topText.skew.x = -0.087;
            this.topText.angle = -5;
            this.addChild(this.topText);
        }
    }

    private layout(): void {
        this.middleText.position.set(this.background.width * 0.5 - this.middleText.width * 0.5, 212);
        this.bottomText.position.set(this.background.width * 0.5 - this.bottomText.width * 0.5, 303);
        if (this.isNewBank) {
            this.topText.position.set(166, 136);
        }
    }
}

class TopTextStyle extends PiggyViewTextStyle {
    public constructor() {
        super();
        this.fontSize = 64;
        this.fill = [
            "FFE302",
            "FF9024"
        ];
    }
}

class MiddleTextStyle extends PiggyViewTextStyle {
    public constructor() {
        super();
        this.fontSize = 128;
        this.letterSpacing = 0.6;
    }
}
